import React from "react";
import Context from "../../../Context";
import List from "../../Misc/List";
import SuperSelect from "../../Misc/SuperSelect";
import ElementListItem from "./ElementListItem";

let searchTimeout = null;

export default class ElementList extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      catalogItem: false,
      textSearchValue: "",
      pending: false,
      searchPending: false,
      critical: false,
      mine: false,
      showall: false,
      manager: false,
      search: [],
      filters: {
        show: false,
        active: [],
        default: [],
        all: [],
      },
      fields: {
        all: [],
        active: [],
      },
      sortings: {
        all: [],
        active: ["sortlist"],
      },
    };
  }

  componentDidMount() {
    this.setDefaultFilters();
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.specId !== this.props.specId ||
      prevProps.shipId !== this.props.shipId
    ) {
      this.setDefaultFilters();
    }
  }

  setDefaultFilters = async () => {
    this.setState({ pending: true });

    let shipId =
      this.props.shipId && this.props.shipId !== "any"
        ? this.props.shipId
        : null;

    this.setState((state) => {
      let filters = state.filters;
      filters.default = [];

      filters.default.push({
        field: "ship",
        compare: "EQL",
        value: shipId,
      });

      if (this.state.critical) {
        filters.default.push({
          field: "critical",
          compare: "EQL",
          value: true,
        });
      }

      if (this.state.mine) {
        filters.default.push({
          field: "manager",
          compare: "EQL",
          value: this.context.user.staffId || this.context.api.nullUuid,
        });
      }

      if (this.state.manager) {
        filters.default.push({
          field: "manager",
          compare: "EQL",
          value: this.state.manager,
        });
      }

      if (this.props.specId && this.props.specId !== "any") {
        filters.default.push({
          field: "specification",
          compare: "EQL",
          value: this.props.specId,
        });
      }

      return filters;
    });
  };

  handleSearch = (searchValue) => {
    this.setState({ textSearchValue: searchValue });
    this.setState({ searchPending: true });
    window.clearTimeout(searchTimeout);
    searchTimeout = window.setTimeout(() => {
      let search = searchValue
        ? [
            {
              lstr: "(",
              field: "label",
              compare: "IKE",
              value: `%${searchValue}%`,
            },
            {
              condition: "OR",
              field: "modelname",
              compare: "IKE",
              value: `%${searchValue}%`,
              rstr: ")",
            },
          ]
        : [];
      this.setState({
        searchPending: false,
        search,
      });
    }, 1500);
  };

  handleSearchCancell = () => {
    window.clearTimeout(searchTimeout);
    this.setState({
      searchPending: false,
      search: [],
      textSearchValue: "",
    });
  };

  toggleCritical = () => {
    this.setState(
      (state) => {
        return { critical: !state.critical };
      },
      () => this.setDefaultFilters()
    );
  };

  toggleMine = () => {
    this.setState(
      (state) => {
        return { mine: !state.mine };
      },
      () => this.setDefaultFilters()
    );
  };

  toggleShowall = () => {
    this.setState(
      (state) => {
        return { showall: !state.showall };
      },
      () => this.setDefaultFilters()
    );
  };

  changeManager = (manager) => {
    this.setState({ manager }, () => this.setDefaultFilters());
  };

  render() {
    const { textSearchValue, manager, critical } = this.state;
    let treePaddingMuliplier = textSearchValue || manager || critical ? 0 : 5;
    return (
      <>
        <div
          className="mb-4"
          onScroll={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <SuperSelect
            grey
            defaultValue={this.state.manager}
            onChange={this.changeManager}
            essence="staff"
            placeholder="По заведующему..."
            nameField="label"
            idField="id"
            isClearable
            orderby={["label ASC"]}
          />
        </div>
        <div className="d-flex mb-4">
          <div className="text-nowrap flex-grow-1 mr-2">
            <div className="input-group">
              <input
                className="form-control form-control-solid d-inline-block"
                type="text"
                placeholder="Поиск оборудования..."
                value={this.state.textSearchValue || ""}
                onChange={(e) => this.handleSearch(e.target.value)}
              />
              {this.state.textSearchValue && !this.state.searchPending ? (
                <div className="input-group-append">
                  <button
                    title="Отменить поиск"
                    className="btn btn-icon btn-secondary"
                    type="button"
                    onClick={() => this.handleSearchCancell()}
                  >
                    <i className="fa text-muted fa-close"></i>
                  </button>
                </div>
              ) : null}
              {this.state.searchPending ? (
                <div className="input-group-append">
                  <div className="btn btn-icon btn-light">
                    <div className="spinner mr-5"></div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <div>
            <button
              title="Критическое оборудование"
              className="btn btn-icon btn-light"
              onClick={this.toggleCritical}
            >
              <i
                className={`fa fa-exclamation-triangle ${
                  this.state.critical && "text-danger"
                }`}
              ></i>
            </button>
            {this.props.extraButtons}
          </div>
        </div>

        <List
          listKey="elementList"
          key={this.props.customListKey}
          fulltext={JSON.stringify(this.state.search)}
          search={JSON.stringify(
            this.state.filters.active.concat(this.state.filters.default)
          )}
          sort={JSON.stringify(this.state.sortings.active)}
          fields={JSON.stringify([
            "id",
            "parent",
            "level",
            "label",
            "modelname",
            "critical",
            "count",
          ])}
          limit={0}
          hideSinglePageNav={true}
          keyField="id"
          path="/element/tree"
          row={this.state.viewGrid}
          onLoadStart={this.onListLoadStart}
          onLoadEnd={this.onListLoadEnd}
          blocker={{ spinnerFixed: true, hAuto: true }}
          treeNode="parent"
        >
          <ElementListItem
            highlightItem={this.props.elementId}
            specId={this.props.specId}
            shipId={this.props.shipId}
            onElementPick={this.props.onElementPick}
            onElementCheck={this.props.onElementCheck}
            checkedElements={this.props.checkedElements || []}
            treePaddingMuliplier={treePaddingMuliplier}
          />
        </List>
      </>
    );
  }
}
